var render = function render(){var _vm=this,_c=_vm._self._c;return _c('arrow-selection-item',{staticClass:"account-selection-item",attrs:{"image-source":require(`@/assets/bank-logos/${_vm.source.logoFile}`),"image-size":"large"},on:{"click":function($event){return _vm.onSelection(_vm.source.sourceName)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }